// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hotReloadContent{z-index:9999;position:fixed;right:10px;bottom:30px}div#hotReloadMonitor{background:linear-gradient(0deg,#22c1c3,#2dfd87);height:0;overflow:hidden;color:#fff;border-radius:.5em;-webkit-animation:hotReloadMonitorfadeout 2s linear 0s 1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
